import { AddressModel } from "./data.address.model";

export class NextOfKinModel {
	nextOfKinName?: string;
	nextOfKinTelephone?: string;
	nextOfKinAddress?: AddressModel;
	nextOfKinRelationship?: string;
	nextOfKinNameError?: string;
	nextOfKinEmail?: string;

	constructor(data: any = {}) {
		this.nextOfKinName = data.nextOfKinName || "";
		this.nextOfKinTelephone = data.nextOfKinTelephone || "";
		this.nextOfKinAddress = data.nextOfKinAddress || new AddressModel();
		this.nextOfKinRelationship = data.nextOfKinRelationship || "";
		this.nextOfKinEmail = data.nextOfKinEmail || "";
	}
}
